import React from "react";
import { usePreguntasCalidad } from "../../hooks";
import { Preguntas } from "../Preguntas";
import usePreguntasPuntualidad from "../../hooks/usePreguntasPuntualidad";
import usePreguntasComunicacionReportes from "../../hooks/usePreguntasComunicacionReportes";
import usePreguntasResponsabilidadManejoVehiculo from "../../hooks/usePreguntasResponsabilidadManejoVehiculo";
import usePreguntasActitudTrabajoEquipo from "../../hooks/usePreguntasActitudTrabajoEquipo";
import usePreguntasConocimientosTecnicos from "../../hooks/usePreguntasConocimientosTecnicos";

const PreguntasConocimientosTecnicos = () => {
	const { frmPreguntas, setPuntajeTotal } = usePreguntasConocimientosTecnicos();

	return (
		<Preguntas
			form={frmPreguntas}
			calcularPuntajeTotal={setPuntajeTotal}
			titulo="Conocimientos técnicos (1/6)"
			opciones={[
				{ key: "dominaDiagnosticoFallasMecanicasYElectricas", label: "Domina el diagnóstico de fallas mecánicas y eléctricas" },
				{ key: "utilizaCorrectamenteHerramientasYEquiposTaller", label: "Utiliza correctamente las herramientas y equipos de taller" },
				{ key: "conoceProcedimientosAdecuadosReparacionesEspecificas", label: "Conoce los procedimientos adecuados para reparaciones específicas" },
				{ key: "estaAlDiaConNuevasTecnologiasOSistemasAutomotrices", label: "Está al día con nuevas tecnologías o sistemas automotrices" }
			]}
		/>
	);
};

export default PreguntasConocimientosTecnicos;
